<template>
  <BranchListingComponent
    editPath="AdminBranchYearEdit"
    :additionalParams="additionalParams"
    :count="count"
    :loading="loading"
    :branches="branches"
    :search="pageOptionsBranchYears.q"
    @updateBranches="handleBranchUpdate"></BranchListingComponent>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { IPaginationDTO, IYearDTO, PaginationDTO } from '@/dtos';
import BranchListingComponent from '@/components/branches/BranchListingComponent.vue';
import { RouteParamsRawGeneric } from 'vue-router';
import { useBranchYearStore } from '@/stores/modules/admin';
import type { VDataTableServer } from 'vuetify/components';

interface Props {
  year: IYearDTO;
}
const props = defineProps<Props>();
const pageOptionsBranchYears = ref<IPaginationDTO>(new PaginationDTO());
const yearId = computed(() => props.year.id);
const branchYearStore = useBranchYearStore();
const { data: branchYearData, isLoading: isLoadingBranchYears } =
  branchYearStore.getAllBranchYearsQuery(yearId, pageOptionsBranchYears);

const branches = computed(() => branchYearData.value?.data);
const loading = computed(() => isLoadingBranchYears);
const count = computed(() => branchYearData.value?.count ?? 0);

const handleBranchUpdate = (value: VDataTableServer) => {
  pageOptionsBranchYears.value.buildPagination(value);
};
const additionalParams: RouteParamsRawGeneric = { yearId: '' };

watch(
  yearId,
  (newYearId) => {
    additionalParams.yearId = newYearId;
  },
  { immediate: true },
);
</script>
